import {Alert} from 'antd'
import {useLocation} from 'react-router-dom'
import {useAppVersionCheck} from 'src/cms/hooks/useAppVersionCheck'

/**
 * Thin bar above the main navbar telling the user their tab is running an
 * outdated bundle. Shown on the dashboard only.
 *
 * Deliberately left in normal flow: the header below it is `position: sticky`,
 * so the banner scrolls away while the navbar stays pinned.
 */
export function VersionUpdateBanner() {
  const {pathname} = useLocation()
  const {latestVersion, isOutdated} = useAppVersionCheck()

  if (!isOutdated || !pathname.startsWith('/dashboard')) {
    return null
  }

  return (
    <Alert
      banner
      showIcon
      type='warning'
      message={
        <span>
          A new version (<strong>{latestVersion}</strong>) is available. Please hard refresh the
          page — <strong>Ctrl + Shift + R</strong>.
        </span>
      }
    />
  )
}

export default VersionUpdateBanner
